import { ICampaignType, IVariantType } from '../types';

export const CAMPAIGN_VARIANT_DESCRIPTION: Partial<
  Record<ICampaignType, Record<IVariantType, string>>
> = {
  [ICampaignType.PRICE]: {
    [IVariantType.VARIANT_A]: 'Active product',
    [IVariantType.VARIANT_B]: 'Unlisted product with testing price',
  },
};
